import { FormEvent, useMemo, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { AuthField } from '../../components/auth/AuthField';
import { AuthPageHeader } from '../../components/auth/AuthPageHeader';
import { AuthPageLayout } from '../../components/auth/AuthPageLayout';
import { PasswordInput } from '../../components/ui/PasswordInput';
import { resetPassword } from '../../services/authApi';

export function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const token = useMemo(() => searchParams.get('token') ?? '', [searchParams]);
  const [newPassword, setNewPassword] = useState('');
  const [confirmNewPassword, setConfirmNewPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);

  async function handleSubmit(event: FormEvent) {
    event.preventDefault();
    if (!token) {
      toast.error('Token inválido.');
      return;
    }

    setSubmitting(true);
    try {
      await resetPassword(token, newPassword, confirmNewPassword);
      setDone(true);
      toast.success('Senha redefinida com sucesso.');
    } catch {
      toast.error('Não foi possível redefinir a senha.');
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <AuthPageLayout>
      <AuthPageHeader
        title="Nova senha"
        subtitle="Defina uma nova senha para acessar sua conta."
      />

      {done ? (
        <p className="text-center text-sm text-secondary-600">
          Senha atualizada.{' '}
          <Link to="/login" className="font-medium text-primary-600 hover:text-primary-700">
            Fazer login
          </Link>
        </p>
      ) : (
        <form className="auth-form" onSubmit={(e) => void handleSubmit(e)}>
          <AuthField label="Nova senha" htmlFor="new-password">
            <PasswordInput
              id="new-password"
              required
              autoComplete="new-password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              placeholder="Digite a nova senha"
              className="auth-field-input"
            />
          </AuthField>
          <AuthField label="Confirmar nova senha" htmlFor="confirm-password">
            <PasswordInput
              id="confirm-password"
              required
              autoComplete="new-password"
              value={confirmNewPassword}
              onChange={(e) => setConfirmNewPassword(e.target.value)}
              placeholder="Repita a nova senha"
              className="auth-field-input"
            />
          </AuthField>
          <button
            type="submit"
            disabled={submitting || !token}
            className="erp-btn-primary w-full py-2.5"
          >
            {submitting ? 'Salvando...' : 'Redefinir senha'}
          </button>
        </form>
      )}

      {!done ? (
        <p className="mt-6 text-center text-sm text-secondary-500">
          <Link to="/login" className="font-medium text-primary-600 hover:text-primary-700">
            Voltar ao login
          </Link>
        </p>
      ) : null}
    </AuthPageLayout>
  );
}
